import { Box, Fade, IconButton, InputAdornment, Modal } from '@mui/material';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { AlternateEmail } from '@mui/icons-material';

import BaseInputValidation from '@/components/ui/Input/BaseInputValidation';
import ButtonCloseModal from '@/components/ui/Button/ButtonCloseModal';
import Loader from '@/components/ui/Loader/Loader';
import usePatch from '@/hooks/usePatch';
import ModalStyle from '@/constants/ModalStyle';
import { toast } from 'react-toastify';

const schema = yup.object().shape({
	email: yup.string().required('Email is a required field').email('Email not valid'),
});

export default function ForgotPassword(props) {
	const { open, onClose } = props;

	const {
		handleSubmit,
		control,
		reset,
		formState: { errors },
	} = useForm({
		resolver: yupResolver(schema),
		defaultValues: {
			email: '',
		},
	});

	const handleClose = () => {
		reset();
		onClose();
	};

	const {
		mutate: resetPassword,
		isPending,
		isSuccess,
	} = usePatch({
		url: `api/auth/password-reset/`,
		method: 'post',
		isAuth: false,
		callback: (res) => {
			toast.success(res.data?.success || `Password Reset has been send to your email`);
		},
		onError: (res) => {
			toast.error(res.data?.detail || `Error`);
		},
		showError: true,
	});

	const onSubmit = (data) => {
		resetPassword(data)
	};
	return (
		<Modal open={open} onClose={handleClose} aria-labelledby='modal-notes' aria-describedby='modal-notes' className='w-full'>
			<Fade in={open} mountOnEnter unmountOnExit>
				<Box sx={{ ...ModalStyle, top: '25%' }} className='flex flex-col gap-4 w-[90%] md:w-[360px]'>
					<span className='text-2xl modal-title'>Glemt passord</span>
					<ButtonCloseModal onClose={handleClose} />

					<form onSubmit={handleSubmit(onSubmit)} className='flex flex-col w-full gap-4'>
						{isPending && !isSuccess && <Loader />}

						<BaseInputValidation
							control={control}
							name='email'
							label='E-Post'
							errors={errors}
							placeholder='E-post'
							config={{ type: 'text', classes: 'pl-0' }}
							InputLabelProps={{ shrink: true }}
							InputProps={{
								startAdornment: (
									<InputAdornment position='start'>
										<IconButton aria-label='toggle password visibility' edge='start'>
											<AlternateEmail />
										</IconButton>
									</InputAdornment>
								),
							}}
							required
						/>
						<div className='flex gap-4 ml-auto'>
							<button className='px-3 py-2 text-white bg-gray-600 rounded-md' onClick={handleClose}>
								Lukk
							</button>
							<button className='px-3 py-2 text-white rounded-md bg-primary' type='submit'>
								Sende
							</button>
						</div>
					</form>
				</Box>
			</Fade>
		</Modal>
	);
}
